/** Set to true to show Glamping across the Stay / accommodations section. */
export const SHOW_GLAMPING = false;

export const isGlampingSlide = (slide) =>
  slide?.title?.toLowerCase().includes('glamping');

export const filterGlampingSlides = (slides) =>
  SHOW_GLAMPING ? slides : slides.filter((slide) => !isGlampingSlide(slide));
